module.exports = __webpack_public_path__ + "assets/f396112ad7ca2e3292637d1f17aac1dd.png";